// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"89769578","315":"ea8d9b56","453":"726a9731","501":"2d77d8d9","513":"593e6c09","692":"f359d3e2"}[chunkId] + ".chunk.js";
};